module.exports = __webpack_public_path__ + "static/media/loop-light.dcefcce2.svg";